var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('app-chart',{attrs:{"type":'horizontal-line-chart',"title":'Horizontal Line Chart',"labels":_vm.labels,"data-sets":_vm.dataSets}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }